/**
 * 希伯来语（he）
 */

import heLocale from 'element-ui/lib/locale/lang/he'

export default {
  ...heLocale,
  common: {},
  // 语言
  lang: {
    english: 'אנגלית',
    spanish: 'ספרדית',
    japanese: 'יפני',
    portuguese: 'פורטוגזית',
    french: 'צרפתית',
    russian: 'רוסית',
    arabic: 'ערבית',
    german: 'גרמנית',
    italian: 'איטלקית',
    vietnam: 'וייטנאם',
    turkey: 'טורקיה',
    korean: 'קוריאנית',
    thai: 'תאילנדית',
    dutch: 'הולנדית',
    hebrew: 'היברית',
    indonesian: 'אינדונזית'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
